import React from "react";
import { Button, Box, Typography } from "@mui/material";
import styles from "../../styles/PaginationComponent.module.css";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import ArrowBackIosNewSharpIcon from "@mui/icons-material/ArrowBackIosNewSharp";
import {ReactComponent as LeftArrow} from "assets/PwC_Funct_Icons_ChevronLeft_Outline_Black_RGB.svg"
import {ReactComponent as RightArrow} from "assets/PwC_Funct_Icons_ChevronRight_Outline_Black_RGB.svg"

const PaginationComponent = ({ pageNumber, totalPages, onPageChange }) => {
  return (
    <Box className={styles.paginationContainer}>
      <Button
        onClick={() => onPageChange(pageNumber - 1)}
        disabled={pageNumber === 1}
        className={styles.paginationButton}
      >
         {/* <ArrowBackIosNewSharpIcon /> */}
        <LeftArrow style={{height: "20px", width: "20px", fontWeight:500, fill:"#252525"}}  />
      </Button>

      <Typography variant="body1" className={styles.pageInfo}>
        {pageNumber}
      </Typography>

      <Typography variant="body1" className={styles.totalPagesCount}>
        of {totalPages}
      </Typography>

      <Button
        onClick={() => onPageChange(pageNumber + 1)}
        disabled={pageNumber === totalPages}
        className={styles.paginationButton}
      >
        {/* <ArrowForwardIosSharpIcon /> */}
        <RightArrow style={{height: "20px", width: "20px", fontWeight:500, fill:"#252525"}} />
      </Button>
    </Box>
  );
};

export default PaginationComponent;
